import { render } from "./ProjectsButton.vue?vue&type=template&id=5cce9414&scoped=true&ts=true"
import script from "./ProjectsButton.vue?vue&type=script&lang=ts"
export * from "./ProjectsButton.vue?vue&type=script&lang=ts"

import "./ProjectsButton.vue?vue&type=style&index=0&id=5cce9414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cce9414"]])

export default __exports__